import { render } from "./PhoneInput.vue?vue&type=template&id=d64f8c3a"
import script from "./PhoneInput.vue?vue&type=script&lang=js"
export * from "./PhoneInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/members.eena.org/releases/81761477/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__